import { Typography } from 'antd';
import styled from '@emotion/styled';
export const Caption = styled(Typography.Text)`
  font-size: 8px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0em;
  color: rgba(137, 145, 160, 1);
`;
